import { __assign } from "tslib";
import React from 'react';
var ImageRenderer = function (imageProps) {
    if (typeof ImageRenderer.customImageRenderer === 'function') {
        return ImageRenderer.customImageRenderer(imageProps);
    }
    else {
        return React.createElement("img", __assign({}, imageProps));
    }
};
export default ImageRenderer;
//# sourceMappingURL=imageRenderer.js.map